import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

api.interceptors.response.use(res => res, async error => {
  const original = error.config;
  if (error.response?.status === 401 && !original._retry && !original.url?.includes('/auth/me/')) {
    original._retry = true;
    try {
      await axios.post(`${API_URL}/auth/refresh/`, {}, { withCredentials: true });
      return api(original);
    } catch {
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
  }
  return Promise.reject(error);
});

export default api;
export const authApi = {
  login: (data: any) => api.post('/auth/login/', data),
  logout: () => api.post('/auth/logout/', {}),
  me: () => api.get('/auth/me/'),
  changePassword: (data: any) => api.post('/auth/change-password/', data),
  setup2fa: () => api.post('/auth/2fa/setup/'),
  verify2fa: (token: string) => api.post('/auth/2fa/verify/', { token }),
  disable2fa: (password: string) => api.post('/auth/2fa/disable/', { password }),
  loginLogs: () => api.get('/auth/login-logs/'),
};
export const cameraApi = {
  list: () => api.get('/cameras/'),
  ptzMove: (id: number, dir: string, step = 10) => api.post(`/cameras/${id}/ptz_move/`, { dir, step }),
};
export const eventApi = { list: (params?: any) => api.get('/events/', { params }) };
export const archiveApi = { list: (params?: any) => api.get('/archive/', { params }) };
export const systemApi = {
  status: () => api.get('/system/status/'),
  history: () => api.get('/system/history/'),
};
export const modemApi = {
  status:         () => api.get('/modem/status/'),
  history:        () => api.get('/modem/history/'),
  connect:        () => api.post('/modem/connect/'),
  disconnect:     () => api.post('/modem/disconnect/'),
  getApn:         () => api.get('/modem/apn/'),
  setApn:         (apn: string, user: string, password: string) =>
                    api.post('/modem/apn/', { apn, user, password }),
  smsList:        () => api.get('/modem/sms/'),
  smsSend:        (number: string, body: string) => api.post('/modem/sms/send/', { number, body }),
  smsDelete:      (index: number) => api.delete(`/modem/sms/${index}/`),
  wifiScan:       () => api.get('/modem/wifi/scan/'),
  wifiStatus:     () => api.get('/modem/wifi/status/'),
  wifiConnect:    (ssid: string, password: string) => api.post('/modem/wifi/connect/', { ssid, password }),
  wifiDisconnect: () => api.post('/modem/wifi/disconnect/'),
};
